import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';

export function SubmitButton({
	hasValidationErrors,
	loading,
}: {
	hasValidationErrors: boolean;
	loading: boolean;
}): JSX.Element {
	return (
		<Button
			type="submit"
			data-testid="submit"
			data-qa="submit"
			disabled={hasValidationErrors}
			loading={loading}
			sx={{ width: ['100%', 'auto'] }}
			loadingLabel="submitting" // TODO translate label
		>
			<Translate value="fe.pages.petition_update_composer.post" />
		</Button>
	);
}
